import { apiGet, apiPost } from './index'

// 获取医院列表
const getHospitalList = params => apiGet('/openapi/wx/getHospitalList', params)

// 获取职称列表
const dataDictionary = params => apiGet('/openapi/wx/dataDictionary', params)

// 获取职称列表
const register = params => apiPost('/openapi/wx/register', params)

// 获取验证码
const sendPhoneMessage = params => apiGet('/openapi/wx/sendPhoneMessage', params)
const sendPhoneMessageForLoginExpire = params => apiGet('/openapi/wx/sendPhoneMessageForLoginExpire', params)

// 获取用户信息
const getIepUserInfo = params => apiGet('/openapi/wx/getIepUserInfo', params)

// 获取用户信息
const getCiamUserInfoByOpenId = iepOpenId => apiGet(`/openapi/wx/getCiamUserInfoByOpenId/${iepOpenId}`)

// 更新用户信息
const updateUserById = params => apiPost(`/api/johnson/iep/users/updateUserById/${params.userId}`, params)

// 我的-资料修改
const updateZiliaoUserById = params => apiPost(`/api/johnson/iep/users/ziliao/updateUserById/${params.userId}`, params)

// 登录验证，长时间没有登录iepOpenId、phone、phoneCode
const loginTimeoutVerifyPhone = (params) => apiPost(`/api/johnson/iep/users/loginTimeoutVerifyPhone`, params)

export { getHospitalList, dataDictionary, register, sendPhoneMessage, sendPhoneMessageForLoginExpire, getIepUserInfo, getCiamUserInfoByOpenId, updateUserById, updateZiliaoUserById, loginTimeoutVerifyPhone }



// WEBPACK FOOTER //
// ./src/api/register.js